import { ClipboardCheck, Plus } from 'lucide-react';
import { href } from '../../lib/router';
import type { AssessmentSummary } from '../assessments/api';
import { useOwnsBusiness } from './context';
import { useStartCheck } from './onboarding';

/** What the business pages show before there is a score to show. */

export function NoAssessment() {
  const own = useOwnsBusiness();
  const start = useStartCheck();
  if (own)
    return (
      <section className="bcard empty-card">
        <span className="hicon big">
          <ClipboardCheck size={22} />
        </span>
        <h2>Start your Cyber Check</h2>
        <p className="muted">
          About 30 minutes of questions about how your business works and protects itself. Your CyberScore
          builds as you answer, with what to fix first.
        </p>
        {start.error && <p className="bad-t small">{start.error.message}</p>}
        <button type="button" className="bbtn pri" disabled={start.isPending} onClick={() => start.mutate()}>
          <Plus size={15} /> {start.isPending ? 'Starting…' : 'Start the Cyber Check'}
        </button>
      </section>
    );
  return (
    <section className="bcard empty-card">
      <span className="hicon big">
        <ClipboardCheck size={22} />
      </span>
      <h2>No Cyber Check yet</h2>
      <p className="muted">
        Your insurer or broker starts a Cyber Check for your business and adds you to it. You will see your
        CyberScore here as soon as they do.
      </p>
    </section>
  );
}

export function ScoreProblem({ a, error }: { a: AssessmentSummary; error: Error | null }) {
  return (
    <section className="bcard empty-card">
      <span className="hicon big">
        <ClipboardCheck size={22} />
      </span>
      <h2>Answer a few questions to see your CyberScore</h2>
      <p className="muted">
        {a.customer_name} · {a.title}. Your score builds as you answer.
        {error && <span className="small"> ({error.message})</span>}
      </p>
      <a className="bbtn pri" href={href.assessment(a.id)}>
        Start the Cyber Check
      </a>
    </section>
  );
}
